import { t } from '@/features/i18n/utils';
import { noop } from '@tanstack/react-query';
import { getDefaultStore } from 'jotai';
import { tasksQuery } from '@/features/tasks/queries';
import {
  tasksDisplayAtom,
  tasksFilterAtom,
  tasksWorkspaceFilterAtom,
} from '@/features/tasks/store';
import { taskListFilters } from '@/features/tasks/utils';
import { createFileRoute } from '@tanstack/react-router';
import { ProjectBreadcrumbs } from '@/features/projects/components/project-breadcrumbs';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Main } from '@/ui/components/main';
import { TasksPage } from '@/features/tasks/components/tasks-page';

export const Route = createFileRoute('/_authed/project/$projectId/tasks')({
  component: RouteComponent,
  loader: ({ context, params }) => {
    const store = getDefaultStore();
    const filters = taskListFilters({
      user: context.auth.user,
      projectId: params.projectId,
      workspaceId: store.get(tasksWorkspaceFilterAtom)[params.projectId],
      filter: store.get(tasksFilterAtom),
      display: store.get(tasksDisplayAtom),
      search: '',
    });
    if (filters) context.queryClient.infiniteQuery(tasksQuery(filters)).catch(noop);
  },
});

function RouteComponent() {
  return (
    <Main>
      <Header>
        <HeaderBackButton />
        <ProjectBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Tasks', nb: 'Oppgaver' })}</BreadcrumbPage>
        </ProjectBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <TasksPage />
    </Main>
  );
}
